import {
  CButton,
  CCloseButton,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
} from '@coreui/react-pro'
import React from 'react'
import { ModalPropsType } from '../../types/Components/modalTypes'

const OModal = ({
  visible,
  setVisible,
  alignment = 'center',
  modalTitle,
  children,
  modalClassName,
  modalHeaderClass,
  modalFooterClass,
  modalBodyClass,
  closeButtonClass,
  modalCancelBtnClass,
  modalConfirmBtnClass,
  modalSize,
  isConfirmButtonDisabled = false,
  isCancelButtonDisabled = false,
  isCloseButtonDisabled = false,
  confirmButtonText = 'Confirm',
  cancelButtonText = 'Cancel',
  backdrop,
  confirmButtonAction,
  cancelButtonAction,
  closeButtonAction,
  disableHeaderCloseButton,
}: ModalPropsType): JSX.Element => {
  const closeBtnHandler = () => {
    if (closeButtonAction) {
      closeButtonAction()
    }
    setVisible(false)
  }

  const cancelBtnHandler = () => {
    if (cancelButtonAction) {
      cancelButtonAction()
    }
    setVisible(false)
  }

  return (
    <>
      <CModal
        className={modalClassName}
        size={modalSize}
        alignment={alignment}
        visible={visible}
        onClose={() => {
          // Ensure consumer close handler runs for header X / ESC / backdrop
          if (closeButtonAction) {
            closeButtonAction()
          } else {
            setVisible(false)
          }
        }}
        backdrop={backdrop}
      >
        <CModalHeader
          className={modalHeaderClass}
          closeButton={
            disableHeaderCloseButton ? false : !isCloseButtonDisabled
          }
        >
          {modalTitle && <strong>{modalTitle}</strong>}
        </CModalHeader>
        {modalHeaderClass?.includes('d-none') && (
          <CCloseButton
            data-testid="modalCloseBtn"
            className={
              closeButtonClass
                ? closeButtonClass
                : 'btn-modal-close cursor-pointer'
            }
            disabled={isCloseButtonDisabled}
            onClick={closeBtnHandler}
          />
        )}
        <CModalBody className={modalBodyClass}>{children}</CModalBody>
        <CModalFooter className={modalFooterClass}>
          <CButton
            className={modalConfirmBtnClass}
            data-testid="modalConfirmBtn"
            color="warning btn-ovh"
            disabled={isConfirmButtonDisabled}
            onClick={confirmButtonAction}
          >
            {confirmButtonText}
          </CButton>
          <CButton
            className={modalCancelBtnClass}
            color="success btn-ovh"
            disabled={isCancelButtonDisabled}
            onClick={cancelBtnHandler}
          >
            {cancelButtonText}
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}
export default OModal
